import { Bell, Trash } from "@phosphor-icons/react";
import { ICONS, relativeAr } from "./_shared";

// One notification row — matches MobileLanding's glass-card aesthetic.
// Clicking marks it as read; the hover-only delete button removes it.
export default function NotificationCard({ n, onRead, onDelete }) {
  const Icon = ICONS[n.icon] || Bell;
  const unread = !n.is_read;
  const urgent = n.priority === "urgent";
  const click = async () => { if (unread) await onRead(n.id); };

  return (
    <article
      data-testid={`notif-row-${n.id}`}
      onClick={click}
      className={`group relative flex gap-3.5 p-4 rounded-[28px] cursor-pointer
        backdrop-blur-md border transition-all duration-200 ease-out
        ${unread
          ? "bg-white/75 border-white/70 shadow-[0_2px_18px_rgba(10,25,47,0.10)]"
          : "bg-white/45 border-white/55 shadow-[0_1px_10px_rgba(10,25,47,0.05)]"
        }`}
    >
      <div
        className={`shrink-0 w-12 h-12 rounded-full flex items-center justify-center
          ${urgent ? "bg-[#FFFBF0] ring-1 ring-[#D4AF37]/60 text-[#A88425]"
                   : "bg-white/85 ring-1 ring-white/80 text-[#0A192F]"}`}
      >
        <Icon size={20} weight="duotone" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between gap-3">
          <h4 className={`text-[16.5px] leading-snug font-tajawal
            ${unread ? "font-extrabold text-black" : "font-bold text-[#1A1A1A]"}`}>
            {n.title}
          </h4>
          <span className="shrink-0 text-[11px] text-[#3F3F3F] font-tajawal font-bold">
            {relativeAr(n.created_at)}
          </span>
        </div>
        <p className={`mt-1.5 text-[14.5px] leading-[1.75] line-clamp-3 font-tajawal
          ${unread ? "text-black" : "text-[#2A2A2A]"}`}>
          {n.body}
        </p>
        {urgent && (
          <span className="mt-2 inline-flex items-center gap-1 text-[11px] font-extrabold text-[#A88425] px-2.5 py-0.5 rounded-full bg-[#FFFBF0] ring-1 ring-[#D4AF37]/40 font-tajawal">
            عاجل
          </span>
        )}
      </div>
      {unread && (
        <span
          aria-hidden="true"
          className="absolute top-3 left-3 w-2 h-2 rounded-full"
          style={{ background: "linear-gradient(135deg, #F4D464 0%, #D4AF37 100%)" }}
        />
      )}
      <button
        data-testid={`delete-notif-${n.id}`}
        onClick={(e) => { e.stopPropagation(); onDelete(n.id); }}
        className="opacity-0 group-hover:opacity-100 transition absolute bottom-3 left-3
                   w-7 h-7 rounded-full bg-white/80 backdrop-blur-sm border border-white/70
                   flex items-center justify-center text-[#7A828B] hover:text-rose-500 hover:border-rose-200"
        aria-label="حذف"
      >
        <Trash size={11} />
      </button>
    </article>
  );
}
